import { Component, OnInit, Inject, ViewChild, HostListener, AfterViewInit, OnDestroy } from "@angular/core";
import _m from "moment";
import { Subscription, from } from "rxjs";
import { Database } from "src/app/_shared/models/publication-search.model";
import { PublicationService } from "src/app/dataset/selectContent/publication-refinecontent/publication-results/publication-refinement.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { map, mergeMap, shareReplay, switchMap, tap, toArray } from "rxjs/operators";
import { AuthtokenService } from "src/app/auth/authtoken.service";
import { VizPublicationService } from "src/app/analysis/analysis-dataset/analysis-refine-content/analysis-refinement.service";
import { AnalysisService } from "src/app/analysis/analysis.service";
import { LOCAL_STORAGE_KEYS } from "src/app/shared/constants/storage-keys";

@Component({
    selector: "tdms-pub-select-modal",
    templateUrl: "./pub-select-modal.html",
    styleUrls: ["./filterpanel.component.scss"],
    standalone: false
})
export class PubSelectModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("modal_first", { static: false }) firstTabIndex: any;
  @ViewChild("modal_last", { static: false }) lastTabIndex: any;
  @ViewChild("modal_search_box", { static: false }) searchBox: any;
  @HostListener("window:keydown.space", ["$event"]) spaceEvent(event: any) {
    if (event.target.className.includes("ps-row")) {
      event.preventDefault();
    }
  }

  pubTableRequest: Subscription;
  dbTableRequest: Subscription;
  search = "";
  pageSize = 100;
  pageIndex = 0;
  workbench: string = localStorage.getItem(LOCAL_STORAGE_KEYS.WORKBENCH)
    ? localStorage.getItem(LOCAL_STORAGE_KEYS.WORKBENCH)
    : "";
  numberOfPubsAvailable = 100;
  length = 0;
  maxPubCount = 10;
  tableList = [];
  isLoading = true;
  selectedItems = [];
  isPubData: boolean;
  searchPlaceholder: string =
    this.data.filterType == "pub" ? "Search by publication title, source type, subject" : "Databases";
  isAsc = true;
  isSearchPopulated = false;
  dataSource = new MatTableDataSource<Database>(this.tableList);
  text: string;
  pageMin: number = 0;
  pageMax:number = 0;
  lastPage: number = 0;

  CONGRESSIONAL_DESC =
    "This collection features published congressional committee hearings with witness testimony from administration officials, experts, business leaders, advocates, and citizens, offering diverse perspectives on legislative proposals and investigations that shape policy decisions.";

  constructor(
    public dialogRef: MatDialogRef<PubSelectModalComponent>,
    private pubservice: PublicationService,
    private visPubservice: VizPublicationService,
    private visDbservice: AnalysisService,
    @Inject(MAT_DIALOG_DATA) public data,
    private authTokenService: AuthtokenService
  ) {}

  ngOnInit() {
    this.isPubData = this.data.filterType === "pub";
    console.log("IS PUB DATA => ", this.data.filterType);
    if (this.data.isWb) {
      if (this.isPubData) {
        this.getPubData();
        if (this.data.filters) {
          this.selectedItems = Object.assign([], this.data.filters);
        }
      } else {
        this.getDbData();
      }
    } else {
      if (this.isPubData) {
        this.getVisPubData();
        if (this.data.filters) {
          this.selectedItems = Object.assign([], this.data.filters);
        }
      } else {
        this.getVisDbData();
      }
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchBox.nativeElement.focus();
    }, 500);
  }

  ngOnDestroy() {
    if (this.pubTableRequest) {
      this.pubTableRequest.unsubscribe();
    }
    if (this.dbTableRequest) {
      this.dbTableRequest.unsubscribe();
    }
  }

  getPubData() {
    this.pubTableRequest = this.pubservice
      .getPublications(this.search, this.workbench, this.pageSize, this.pageIndex * this.pageSize)
      .subscribe((resolverResponse) => {
        this.tableList = resolverResponse.hits;
        this.length = resolverResponse.docsFound;
        this.isLoading = false;
        this.searchBox.nativeElement.focus();
        this.getPaginationParams();
      });
  }

  getVisPubData() {
    this.pubTableRequest = this.visPubservice
      .getPublications(this.search, this.pageSize, this.pageIndex * this.pageSize)
      .subscribe((resolverResponse) => {
        this.tableList = resolverResponse.hits;
        this.length = resolverResponse.docsFound;
        this.isLoading = false;
        this.searchBox.nativeElement.focus();
        this.getPaginationParams();
      });
  }

  getPaginationParams() {
    this.lastPage = Math.floor(this.length / this.pageSize);
    this.pageMin = Math.max(this.pageIndex - 4, 0);
    this.pageMax = Math.min(this.pageIndex + 5, Math.ceil(this.length / this.pageSize));
  }

  goToPage(pageIndex: number) {
    this.isLoading = true;
    this.pageIndex = pageIndex;
    if(this.data.isWb){
      this.getPubData();
    } else {
      this.getVisPubData();
    }
    
  }


  // loopTabindex(index: string, event: KeyboardEvent) {
  //   if (index === "lastTabIndex") {
  //     event.preventDefault();
  //     this.firstTabIndex.nativeElement.focus();
  //   } else if (event.shiftKey && event.key == "Tab") {
  //     event.preventDefault();
  //     this.lastTabIndex.nativeElement.focus();
  //   }
  // }

  getDbData() {
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.DB_LIST_PREFIX + this.workbench)) {
      this.tableList = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DB_LIST_PREFIX + this.workbench));
      this.dataSource.data = this.tableList;
      this.isLoading = false;
      if (this.data.filters) {
        this.getSelectedDbs();
      }
    } else {
      const subscriptionInfo$ = this.pubservice.getDatabaseSubscription(this.workbench).subscribe((dbMonikers) => {
        dbMonikers.products = dbMonikers.products
          .filter((moniker) => moniker.moniker !== "tdmwos")
          .sort((a, b) => (a.moniker > b.moniker ? 1 : -1));
        for (const db of dbMonikers.products) {
          this.pubservice.getMonikerInfo(db.moniker).subscribe((dbInfo) => {
            if (dbInfo.description) {
              if (dbInfo.moniker === "congressional") {
                dbInfo.description = this.CONGRESSIONAL_DESC;
              }
              this.dataSource.data.push(dbInfo);
              this.dataSource.data.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
              this.tableList = this.dataSource.filteredData;
              if (dbMonikers.products.length == this.dataSource.data.length) {
                this.isLoading = false;
                localStorage.setItem(
                  LOCAL_STORAGE_KEYS.DB_LIST_PREFIX + this.workbench,
                  JSON.stringify(this.dataSource.data)
                );
                if (this.data.filters) {
                  this.getSelectedDbs();
                }
              }
            }
          });
        }
      });
    }
  }

  getVisDbData() {
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.DB_LIST_PREFIX + JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER)).name)) {
      this.tableList = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEYS.DB_LIST_PREFIX + JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER)).name)
      );
      this.isLoading = false;
      if (this.data.filters) {
        this.getSelectedDbs();
      }
    } else {
      const subscriptionInfo$ = this.visDbservice.getDatabaseSubscription().subscribe((dbMonikers) => {
        dbMonikers.products = dbMonikers.products
          .filter((moniker) => moniker.moniker !== "tdmwos")
          .sort((a, b) => (a.moniker > b.moniker ? 1 : -1));
        for (const db of dbMonikers.products) {
          this.pubservice.getMonikerInfo(db.moniker).subscribe((dbInfo) => {
            if (dbInfo.description) {
              if (dbInfo.moniker === "congressional") {
                dbInfo.description = this.CONGRESSIONAL_DESC;
              }
              this.dataSource.data.push(dbInfo);
              this.dataSource.data.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
              this.tableList = this.dataSource.filteredData;
              if (dbMonikers.products.length == this.dataSource.data.length) {
                this.isLoading = false;
                localStorage.setItem(
                  LOCAL_STORAGE_KEYS.DB_LIST_PREFIX + JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER)).name,
                  JSON.stringify(this.dataSource.data)
                );
                if (this.data.filters) {
                  this.getSelectedDbs();
                }
              }
            }
          });
        }
      });
    }
  }

  getDate(pub): string {
    let startDate = pub.find((x) => x.name === "startDate") ? pub.find((x) => x.name === "startDate").value : "";
    const endDate = pub.find((x) => x.name === "endDate") ? pub.find((x) => x.name === "endDate").value : "";
    let endDateDisplay = endDate[0] === "9999-01-01T00:00:00Z" ? "current" : _m(endDate).format("YYYY");

    if (startDate && endDate) {
      return _m(startDate).format("YYYY") + " - " + endDateDisplay;
    } else if (startDate) {
      return _m(startDate).format("YYYY");
    } else if (endDate) {
      return endDateDisplay;
    }
    return "";
  }

  getFullText(pub): string {
    return pub.find((x) => x.name === "hasFullText") ? "Full text" : "";
  }

  getTitle(pub): string {
    return pub.find((x) => x.name === "title") ? pub.find((x) => x.name === "title").value : "";
  }

  getSourceType(pub): string {
    return pub.find((x) => x.name === "sourceType") ? pub.find((x) => x.name === "sourceType").value : "";
  }

  getSubject(pub): string {
    return pub.find((x) => x.name === "subject")
      ? pub
          .find((x) => x.name === "subject")
          .value.toString()
          .replace("|", " | ")
      : "";
  }

  getDbTitle(db: Database) {
    return db.name;
  }

  getDbDescription(db: Database): string {
    if (db.description.split(" ").length > 20) {
      const desc = db.description.split(" ");
      desc.length = 20;
      return desc.join(" ") + "...";
    }
    return db.description;
  }

  getDbFullText(db: Database): string {
    return db.hasFullText ? "Full text" : "";
  }

  onSearch(value: string) {
    if (this.isPubData) {
      this.isLoading = true;
      this.search = value;
      this.pageIndex = 0;
      if (this.data.isWb) {
        this.getPubData();
      } else {
        this.getVisPubData();
      }
    } else {
      this.dataSource.filter = value;
      this.tableList = this.dataSource.filteredData;
    }
  }

  onLiveSearch(value: string) {
    if (!this.isPubData) {
      this.onSearch(value);
    }
  }

  getSelectedDbs() {
    for (const db of this.data.filters) {
      if (this.tableList.find((database) => database.moniker == db.moniker)) {
        this.selectedItems.push(this.tableList.find((database) => database.moniker == db.moniker));
      }
    }
  }

  clearFilter(filter) {
    this.selectedItems = this.isPubData
      ? this.selectedItems.filter((x) => x.id !== filter.id)
      : this.selectedItems.filter((x) => x.moniker !== filter.moniker);
    this.data.filters = this.selectedItems;
  }

  getModalTitle() {
    if (this.isPubData) {
      return "Publication Titles (" + this.length + ")";
    }
    return "Databases (" + this.tableList.length + ")";
  }

  isChecked(item): boolean {
    if (this.isPubData) {
      return this.selectedItems.filter((x) => x.id === item.id).length > 0;
    }
    return this.selectedItems.filter((x) => x.moniker === item.moniker).length > 0;
  }

  togglePubSelection(pub) {
    //Extract the pubId and pubTitle from pub-row.
    let title = "";
    const id = pub.id;
    pub.field.forEach((item) => {
      if (item.name === "title") {
        title = item.value[0];
      }
    });

    if (this.isChecked(pub)) {
      this.selectedItems = this.selectedItems.filter((x) => x.id !== pub.id);
    } else {
      this.selectedItems.push({ id, title });
      console.log("SELECTED ITEMS => ", JSON.stringify(this.selectedItems));
    }
  }

  clearSelection() {
    this.selectedItems = [];
    this.dialogRef.close({ event: "clearSelection", data: this.selectedItems });
  }

  toggleDbSelection(db) {
    if (this.isChecked(db)) {
      this.selectedItems = this.selectedItems.filter((x) => x.moniker !== db.moniker);
    } else {
      this.selectedItems.push(db);
    }
  }

  onDone() {
    if (this.isPubData) {
      const selectedPubFilterValues = [];
      console.log("SELECTED ITEMS => ", this.selectedItems);
      //this.selectedItems.map(item => item.field.filter(x => x.name === 'title').map(i => selectedPubFilterValues.push(i.value[0])));
      this.dialogRef.close({ event: "pubSelect", data: this.selectedItems });
    } else {
      this.dialogRef.close({ event: "dbSelect", data: this.selectedItems });
    }
  }

  goToPubPage(event: Event, pubId: number) {
    event.stopPropagation();
    this.authTokenService.openPubPage(pubId);
  }

  goToDbPage(event: Event, moniker: string) {
    event.stopPropagation();
    this.authTokenService.openDatabasePage(moniker);
  }
}
